/*import axios from 'axios'
import React, { Component } from 'react'*/
import React, { Component } from 'react'
import $ from 'jquery';
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { NavbarLog } from '../../navbar/NavbarLog';
import { Table, Button, Container, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, ListGroupItemText } from 'reactstrap';
//import "./Carrera.css";
import { ApiUrl } from '../../services/ApiRest';
import swal from 'sweetalert';

//Rutas de ingreso de matriz
const carrerasUrl = ApiUrl + "listarcarreras" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const UrlListarDepartamentos = ApiUrl + "listardepartamentos" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlInsertarDepartamento = ApiUrl + "insertardepartamento" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const UrlListarUsiarioAdm = ApiUrl + "listusuariosadm" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";

let listaauxiliar = [];
const itemsPerPage = 3;

export default class GestionDepartamentos extends Component {

    constructor(props) {
        super(props)

        this.state = {
            pagina: 0,
            administrativos: [],
            modalReportIngresarDpt: false,
            //nuevas variables
            listadepartamentos: [],
            //variables para paginacion
            currentItems: null,
            pageCount: 0,
            itemOffset: 0,
            count: 0,
        }
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
    }

    handleChangeListarAdm() {
        axios.get(UrlListarUsiarioAdm)
            .then(res => {
                const administrativos = res.data.data;
                this.setState({ administrativos });
            })
    }

    handleChangeListarDepartamentos = async (e) => {
        //departamentos
        axios.get(UrlListarDepartamentos)
            .then(respuesta => {
                const departamento = respuesta.data.data;
                this.setState({ departamento });
                this.setState({ listadepartamentos: departamento });
                listaauxiliar = this.state.listadepartamentos;

                //PAGINACION
                this.state.itemOffset = 0;
                const endOffset = this.state.itemOffset + itemsPerPage;
                this.setState({ currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });

                this.setState((state) => {
                    return { itemOffset: state.itemOffset + endOffset }
                });
            })
    }

    componentDidMount() {
        document.addEventListener("keydown", this.escFunction, true);
        this.handleChangeListarDepartamentos();
        this.handleChangeListarAdm();
    }

    //FUNCION DE PAGINACION POR  MEDIO DE UN CLIC
    handlePageClick = (event) => {
        this.setState({ pagina: event.selected });
        const newOffset = (event.selected * itemsPerPage) % listaauxiliar.length;
        this.setState((state) => {
            return { itemOffset: newOffset }
        });
        const endOffset = newOffset + itemsPerPage;
        this.setState({ currentItems: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
        this.setState((state) => {
            // Importante: lee state en vez de this.state al actualizar.
            return { itemOffset: newOffset }
        });
    }
    //FIN DE PAGINACION

    mostrarModalIngresar = () => {
        this.setState({ id: 0 });
        this.setState({ modalReportIngresarDpt: true });
    }

    mostrarModalModificar = (registro) => {
        $(function () {
            $("#id").val(registro.id_departamento);
            $("#nombre").val(registro.nombre_departamento);
            $("#estadodpt").val(registro.estado_departamento);
            $("#encargado").val(registro.administrativo_id);
        });

        this.setState({ id: registro.id_departamento });
        this.setState({ nombre: registro.nombre_departamento });
        this.setState({ estadodpt: registro.estado_departamento });
        this.setState({ encargado: registro.administrativo_id });
        this.setState({ modalReportIngresarDpt: true });
    }

    ocultarModalIngresar = () => {
        this.setState({ modalReportIngresarDpt: false });
    }

    registrarDpt = () => {

        const f = new FormData();
        f.append("id", this.state.id);
        f.append("nombre", this.state.nombre);
        f.append("estadodpt", this.state.estadodpt);
        f.append("administrativo_id", this.state.encargado);

        const config = {
            headers: { 'content-type': 'multipart/form-data' }
        }

        axios.post(urlInsertarDepartamento, f, {

        }, config)
            .then(response => {
                if (response.data.success === true) {
                    swal({
                        text: "Operación Exitosa!!",
                        icon: "success",
                        button: "Aceptar",
                    });
                    axios.get(UrlListarDepartamentos)
                        .then(respuesta => {
                            const departamento = respuesta.data.data;
                            this.setState({ departamento });
                            this.setState({ listadepartamentos: departamento });
                            listaauxiliar = this.state.listadepartamentos;

                            if (this.state.pageCount == 1) {
                                this.setState({ itemOffset: 0 });
                            }
                            
                            //PAGINACION
                            const newOffset = (this.state.pagina * itemsPerPage) % listaauxiliar.length;
                            this.setState((state) => {
                                return { itemOffset: newOffset }
                            });
                            const endOffset = newOffset + itemsPerPage;
                            //const endOffset = (this.state.pageCount * itemsPerPage) % listaauxiliar.length;
                            this.setState({ currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                            this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
                            this.setState({ itemOffset: newOffset });
                        })
                    this.ocultarModalIngresar();
                }
            })
            .catch(error => {
                this.setState({ error: "No existe conexión con el servidor" });
                swal({
                    text: "No existe conexión con el servidor",
                    icon: "error",
                    button: "Aceptar",
                });
            });
    }

    render() {
        return (
            <div className="row animate__animated animate__fadeIn">
                <ol className="breadcrumb mb-4">
                    <li className="breadcrumb-item active">{this.state.estado}</li>
                </ol>
                <div className="card shadow p-3 mb-5 bg-white rounded">
                    <div className="card-header back-istmas">
                        <i className="far fa-sticky-note"></i>
                        <b> Gestión de Departamentos Institucionales</b>
                    </div>
                    <div className="card text-center ">
                        <div className="card-header ">
                            REPORTE DE DEPARTAMENTOS
                        </div>
                        <div class="table-responsive">
                            <table className="table table-bordered" id="tablaasignaturas" name="tablaasignaturas" width="100%" >
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Nombre</th>
                                        <th>Estado</th>
                                        <th>Encargado</th>
                                        <th>Opciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.currentItems && this.state.currentItems.map((consola) => (
                                        <tr key={consola.id_departamento}>
                                            <td class="id">{consola.id_departamento}</td>
                                            <td class="nombre">{consola.nombre_departamento}</td>
                                            {(() => {
                                                if (consola.estado_departamento == "Activo") {
                                                    return <td class="estadodpt table-success">{consola.estado_departamento}</td>
                                                }
                                                else {
                                                    return <td class="estadodpt table-danger">{consola.estado_departamento}</td>
                                                }
                                            })()}
                                            <td class="nombre">{consola.nombres_administrativo} {consola.apellidos_administrativo}</td>
                                            <td class="detalle">
                                                <button onClick={() => this.mostrarModalModificar(consola)} > <i className=" fas fa-clipboard-list" ></i></button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div class="table-responsive">
                                <ReactPaginate
                                    nextLabel="next >"
                                    onPageChange={this.handlePageClick}
                                    pageRangeDisplayed={5}
                                    pageCount={this.state.pageCount}
                                    marginPagesDisplayed={2}
                                    previousLabel="< previous"
                                    pageClassName="page-item"
                                    pageLinkClassName="page-link"
                                    previousClassName="page-item"
                                    previousLinkClassName="page-link"
                                    nextClassName="page-item"
                                    nextLinkClassName="page-link"
                                    breakLabel="..."
                                    breakClassName="page-item"
                                    breakLinkClassName="page-link"
                                    containerClassName="pagination"
                                    activeClassName="active"
                                    renderOnZeroPageCount={null}
                                />
                            </div>
                            <Modal isOpen={this.state.modalReportIngresarDpt} >
                                <ModalHeader>
                                    Registro de Departamento
                                </ModalHeader>
                                <ModalBody>
                                    <FormGroup>
                                        <div className="mb-3 centrar">
                                            <input type="hidden" name="id" class="id" id="id" value="" />
                                            <label className="form-label">Nombre:</label>
                                            <input type="text" id="nombre" name="nombre" onChange={this.handleChange} className="form-control" placeholder="" autocomplete="off" required />
                                            <label className="form-label">Estado:</label>
                                            <select className="form-select" id="estadodpt" name="estadodpt" value={this.state.value} onChange={this.handleChange} aria-label="Default select example" autocomplete="off" required>
                                                <option value="">Seleccione</option>
                                                <option value="Activo">Activo</option>
                                                <option value="Inactivo">Inactivo</option>
                                            </select>
                                            <label className="form-label">Encargado:</label>
                                            <select className="form-select" id="encargado" name="encargado" value={this.state.value} onChange={this.handleChange} aria-label="Default select example" required>
                                                <option value="">Seleccione</option>
                                                {this.state.administrativos.map(person => <option key={person.id_administrativo} value={person.id_administrativo} > {person.nombres_administrativo + " " + person.apellidos_administrativo}</option>)}
                                            </select>
                                        </div>
                                    </FormGroup>
                                </ModalBody>
                                <ModalFooter>

                                    <button class="btn btn-outline-primary" onClick={() => this.registrarDpt()} > Ingresar</button>
                                    <button class="btn btn-outline-primary" onClick={() => this.ocultarModalIngresar()}>Salir</button>

                                </ModalFooter>
                            </Modal>
                            <div className="text-center">
                                <button id="agregar" type="button"
                                    className="btn  back-istmas centrar"
                                    style={{ margin: "5px", width: "170px" }}
                                    onClick={() => this.mostrarModalIngresar()} >
                                    <b>Registrar</b>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

